export const ENDPOINTS = {
  get_participants: "teaming/explore/participants/",
  get_teams: "teaming/explore/teams/",
  send_invite: "teaming/explore/teams/invite",
  send_request: "teaming/request/",
};